module.exports = __webpack_public_path__ + "img/tanker.50b9b501.png";